var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMvprIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.04 199.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M121.47,48.68l-.33.32.33,0,.18-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M273.13,118.84l-72.69,72.69a27,27,0,0,1-38.21,0l-9.64-9.64,19.1-18.12,9.64,9.63L255,99.73,181.33,26.05,107.65,99.73l19.59,19.59-18.62,18.62-19.1-19.1a27,27,0,0,1,0-38.23L162.23,7.92a27,27,0,0,1,38.21,0l72.69,72.71A27,27,0,0,1,273.13,118.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M140.06,30v0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M189.13,120.34,119.46,190a29.15,29.15,0,0,1-41.25,0L8.54,120.34a29.15,29.15,0,0,1,0-41.23L78.21,9.44a29.17,29.17,0,0,1,41.25,0l8,8L108.8,36l-10-10L25.17,99.73,98.84,173.4,172.5,99.73l-20-20,1.42.18,18-18,17.24,17.24A29.15,29.15,0,0,1,189.13,120.34Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvprIcon);
export default __webpack_public_path__ + "static/media/mvpr-icon.710ceb7533c5bec77c57ad25281c3d86.svg";
export { ForwardRef as ReactComponent };